import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import ReactSelect from 'react-select';
import SoftBox from "components/SoftBox";
import { useQueryClient } from "@tanstack/react-query";
import { useAgencyInfo } from "context/agency";
import infoimg from "../info.png";
import axios from "axios";
import SoftTypography from "components/SoftTypography";
import ModelPromptslabels from "../../../UiPrompts/promptlabels/ModelPrompts/Create"
import { Tooltip } from "@mui/material";
import { useCreateAssistant, useCreateTemplate, useModelOptions } from "queries/prompts";
import { usePromptLabels } from "queries/promptLabels";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";

const { POST } = ReqMethods;
function ModalComponent({ open, onClose, handleRefresh, supperAdminData }) {
  const queryClient = useQueryClient();
  const [agency] = useAgencyInfo();
  const [contentCreativity, setContentCreativity] = useState(1);
  const [btgen, setBtgen] = useState(1);
  const [waiting, setWaiting] = useState(false);
  const [modalName, setModalName] = useState([]);
  const [tags, setTags] = useState([]);
  const [addTagModel, setAddTagModel] = useState(false);
  const [checkbox, setCheckbox] = useState(false)
  const [payloadodpendora, setpayloadodpendora] = useState({
    instructions: '',
    tools: [],
    temperature: '',
    top_p: '',
    model: '',
    tagsa: [],
    agency_id: '',
    profile_id: "",
    name: "",
    template_id: ""
  })

  const [purposeInfo, setPurposeInfo] = useState(false)

  const request = useRequest();
  const { mutateAsync: createAssistant } = useCreateAssistant();
  const { mutateAsync: createTemplate } = useCreateTemplate();

  const handleSubmit = async (e) => {
    setWaiting(true);
    e.preventDefault();
    const payload = {
      name: e.target.assistant_name.value,
      instructions: e.target.purpose.value,
      model: "openai/gpt-4o",
      temperature: contentCreativity,
      top_p: btgen,
      tags: tags,
      agency_id: agency._id,
      profile_id: agency._id,
      read_only: checkbox,
      type: "agency",
      status: true
    };
    let newAssistant;

    if (checkbox === true) {
      newAssistant = await createAssistant(payload);
    } else {
      newAssistant = await createTemplate(payload);
    }

    if (newAssistant) {
      onClose();
      setWaiting(false);
      setCheckbox(false)
    }

    setContentCreativity(1)
    setBtgen(1)
  };

  const handleChangeTags = (selectedOptions) => {
    // setTags(selectedOptions ? selectedOptions?.map(option => option.value) : []);
    setTags(selectedOptions ? selectedOptions : []);
  };

  const handleCCInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;


    const rangeInput = document.querySelector(".range-input");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }

    setContentCreativity(tempSliderValue);
  };


  const handleBtInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input1");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }
    setBtgen(tempSliderValue);
  };

  // Return intentionally unused - matches the old AppService-era code,
  // which never destructured this query's data either (see queries/
  // prompts.js's useModelOptions for why it's kept as-is).
  useModelOptions();

  const { data: tagsoption = [] } = usePromptLabels(
    { agencyId: agency?._id },
    {
      select: (data) =>
        (data || [])
          .filter(option => option.agency_id === agency._id)
          .filter(option => ['team', 'template', 'user'].includes(option.api_type)),
    },
  );

  // Inlined rather than queries/promptLabels.js's useCreatePromptLabel - that
  // hook doesn't pass toaster, and this call site always has, so reusing it
  // would silently drop the success/error toast.
  const savedataPromptLabel = async (formData) => {
    const updatedFormData = {
      ...formData,
      agency_id: agency._id,
      type: "agency"
    };

    const { response } = await request(POST, "/promptslabel/create", {
      payload: updatedFormData,
      toaster: true,
    });
    // Unconditional, like the old useMutation's onSuccess (which fired on
    // every resolved call since the AppService wrapper never threw either).
    queryClient.invalidateQueries({ queryKey: ['prompt-labels'] });
    if (response) {
      handleclose();
      setAddTagModel(false);
    }

  }
  const handleclose = () => {
    setAddTagModel(false);
  }
  const handleAddTag = () => {
    setAddTagModel(true);
  }
  const handlechecbox = () => {
    setCheckbox(!checkbox)
  }
  return (
    <>
      {open && (
        <div className="modal-zz-confirm text-left">
          <div className="p-2 scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
            <h2 className='text-black text-left font-14' style={{ fontWeight: "700" }}> Create Template </h2>
            <span className='crossison' onClick={onClose}>X</span>
            <SoftBox component="form" onSubmit={handleSubmit}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <SoftBox className="mt-2">
                    <label className="text-black">Template Name</label>
                    <input className="form-control-agust" placeholder="Template Name" name="assistant_name" required />
                  </SoftBox>
                </Grid>

                <Grid item xs={12} style={{ marginTop: '14px' }}>
                  <SoftBox className="mt-2">

                    <label className="text-black" style={{ display: "flex", alignItems: "center", position: "relative", width: "fit-content" }} >
                      <span>Purpose</span>

                      <Tooltip PopperProps={{
                        sx: {
                          "& .MuiTooltip-tooltip": {
                            maxWidth: "none",
                            width: "400px", // Set your desired width here
                          },
                        },
                      }} placement="top" title={supperAdminData?.assistant_purpose}>
                        <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                      </Tooltip>
                    </label>

                    <textarea className="form-control-agust" name="purpose" rows={4} style={{ width: "100%", padding: '14px' }} required></textarea>
                  </SoftBox>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <SoftBox className="mt-2">
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }} >
                      <span>Content Creativity</span>
                      <Tooltip PopperProps={{
                        sx: {
                          "& .MuiTooltip-tooltip": {
                            maxWidth: "none",
                            width: "400px", // Set your desired width here
                          },
                        },
                      }} placement="top" title={supperAdminData?.content_creativity}>
                        <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input type="range" value={contentCreativity} min="0" max="2" step={'0.01'} onChange={handleCCInputChange} className="range-input" />
                      <input
                        type="number"
                        value={contentCreativity}
                        min="0"
                        max="2"
                        step="0.01"
                        onChange={(event) => handleCCInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black"
                        }}
                        className="height_25 bg_transparent removeControl"
                      />
                    </div>
                  </SoftBox>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <SoftBox className="mt-2">
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }} ><span>Balance Text Generation</span>
                      <Tooltip PopperProps={{
                        sx: {
                          "& .MuiTooltip-tooltip": {
                            maxWidth: "none",
                            width: "400px", // Set your desired width here
                          },
                        },
                      }} placement="top" title={supperAdminData?.balance_text_generation}>
                        <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input type="range" value={btgen} min="0" max="1" step={'0.01'} onChange={handleBtInputChange} className="range-input1" />

                      <input
                        type="number"
                        value={btgen}
                        min="0"
                        max="1"
                        step="0.01"
                        onChange={(event) => handleBtInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black"
                        }}
                        className="height_25 bg_transparent"
                      />
                    </div>
                  </SoftBox>
                </Grid>

                <Grid item xs={12}>
                  <SoftBox className="margin-top-10px">
                    <SoftTypography className="text-black w-100 d-flex justify-content-between" variant="button" sx={{ fontSize: "14px", fontWeight: "500", alignItems: 'center' }} mb={1}>
                      <label className='w-50 new_dezin_label text-black ' style={{ display: "flex", alignItems: "center" }}>
                        <span>Tags*</span>

                        <Tooltip PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }} placement="top" title={supperAdminData?.assistant_tags}>
                          <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                        </Tooltip>

                      </label>
                      {/* <p className='w-50 text-right new_dezin_label text-black cursor-pointer' onClick={handleAddTag}>
                        + Add Tag
                      </p> */}
                    </SoftTypography>
                    <ReactSelect
                      name='tags'
                      className="form-input w-full"
                      options={Array.isArray(tagsoption) ? tagsoption.map((item) => ({
                        label: item.name,
                        value: item._id
                      })) : []}
                      isMulti={true}
                      onChange={handleChangeTags}
                    />
                  </SoftBox>
                </Grid>
              </Grid>

              <SoftBox mt={1}>
                <button className="savebtn-setting w-100 position-relative" type="submit" disabled={waiting}>
                  {waiting && (
                    <div class="spinner" style={{
                      width: '16px',
                      height: '16px',
                      display: "inline-block",
                      marginRight: "8px"
                    }}></div>
                  )}
                  Create Template
                </button>
              </SoftBox>
            </SoftBox>
          </div>
        </div >
      )
      }
      {
        addTagModel && (
          <ModelPromptslabels data={null} modelfunctionality={savedataPromptLabel} openModel={addTagModel} onclosemodel={handleclose} />
        )
      }
    </>
  );
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
};

function Create({ products, apps, handleRefresh, supperAdminData }) {
  const [openAddMember, setOpenAddMember] = useState(false);

  return (
    <div style={{ textAlign: "right" }}>
      <button className="btn btn-outline-dark" onClick={() => setOpenAddMember(true)}>
        Create Template
      </button>
      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        products={products}
        apps={apps}
        handleRefresh={handleRefresh}
        supperAdminData={supperAdminData}
      />
    </div>
  );
}

Create.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};

export default Create;
